import React, { useCallback } from 'react';
import { withRouter } from 'react-router';
import firebase, { db } from '../../firebase/base';

import Button from '../button/Button';

import { Form, ChangeMethod } from './SignUp.styles';

const SignUp = ({ history, setSignInUp }) => {
  const handleSignUp = event => {
    event.preventDefault();
    const { email, password, name } = event.target.elements;
    let userId;

    // Create User
    firebase
      .auth()
      .createUserWithEmailAndPassword(email.value, password.value)
      .then(data => {
        userId = data.user.uid;
      })
      .then(() => {
        const userCredentials = {
          name: name.value,
          email: email.value,
          createdAt: new Date().toISOString()
        };

        db.collection(`users`)
          .doc(userId)
          .set(userCredentials);
        history.push('/');
      })
      .catch(err => alert(err));
  };

  return (
    <div>
      <Form onSubmit={handleSignUp}>
        <h1>Create Account</h1>
        <span>It’s quick and easy.</span>
        <input name="name" type="text" placeholder="Name" required />
        <input name="email" type="email" placeholder="Email" required />
        <input
          name="password"
          type="password"
          placeholder="Password"
          required
        />
        <Button>Sign Up</Button>
        <ChangeMethod onClick={() => setSignInUp(true)}>
          Already have an account?
        </ChangeMethod>
      </Form>
    </div>
  );
};

export default withRouter(SignUp);
